<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        created(){
            let activeId = this.$route.query.activeId;
            this.formData.cols = [
                {title: window.$t('txmis.accountReward.activeId'), field: 'activeId',data:activeId,hidden:true},
                {click: window.$t('txmis.bt.search')},
            ]
        },
        methods: {
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('txmis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }
            },
        },
        data() {
            return {
                queryData: {},
                dataForm: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: []
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.tradingRebate.blackList, //请求路径和参数
                    selection: false,
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('txmis.rewardDealList.currentCustomerNumber'), field: 'currentCustomerNumber'},
                        {title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                    ]
                }
            }
        }
    }
</script>
